import { lazy, Suspense } from "react";

import HdLoader from "@hd/ui-kit/hd-loader/HdLoader";
import HdOffcanvas from "@hd/ui-kit/hd-offcanvas/HdOffcanvas";

// import DefaultMessagesPanel from "./components/DefaultMessagesPanel";
import { useAIPanelStore } from "./ai-panel.store";

interface AIPanelProps {
  loggedUserFirstName: string;
}

const AIPanelContent = lazy(
  () => import("./AIPanelContent")
);

function AIPanel({
  loggedUserFirstName
}: AIPanelProps) {
  const isOpen = useAIPanelStore((state) => state.isOpen);
  const close = useAIPanelStore((state) => state.close);
  
  return (
    <HdOffcanvas
      isOpen={isOpen}
      position="right"
      onClose={close}
      backdrop={true}
    >
      <div
        className="flex h-full text-bodyText text-xs relative bg-white"
        style={{ width: "800px" }}
      >
        <Suspense fallback={<HdLoader></HdLoader>}>
          <AIPanelContent
            loggedUserFirstName={loggedUserFirstName}
          ></AIPanelContent>
        </Suspense>
      </div>
    </HdOffcanvas>
  );
}

export default AIPanel;